import React from 'react'
import project1 from '../assets/img/project1.png'
import project2 from '../assets/img/project2.png'
import project3 from '../assets/img/project3.png'
import project4 from '../assets/img/project4.png'

function Projects() {

  return (
    <section className="py-10 bg-gray-100 sm:py-16 lg:py-24">
        <div className="bg-white border border-neutral-300 py-4 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 lg:py-8">
            <div className="max-w-2xl mx-auto text-center">
                <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl">Things I've Worked on</h2>
                <p className="max-w-lg mx-auto mt-4 text-base leading-relaxed text-gray-600">
                I am always eager to take on new challenges and learn new technologies.
                I have a diverse set of skills and a passion for creating innovative solutions.
                </p>
            </div>

            <div className="grid grid-cols-1 gap-6 px-4 mt-12 sm:px-0 xl:mt-20 xl:grid-cols-4 sm:grid-cols-2">
              {projects.map((project, i) => (
                <div className="overflow-hidden bg-gray-100" key={project.title}>
                    <div className="px-5 py-6">
                      <div className="flex items-center justify-between">
                        <img className=" object-cover w-full h-10 " src={project.image} alt={project.title} />
                      </div>
                      <blockquote className="mt-5">
                        <p className="text-base text-gray-800">
                          {project.description}
                          <a href={project.viewLink} target="_blank" rel="noreferrer"  className="block text-primaryGreen">View Project</a>
                        </p>
                      </blockquote>
                          <div className="flex justify-start flex-wrap ">
                            {project.stack.map((tech, j) => (
                              <div key={j} className="mr-2 mt-2 text-sm font-medium text-gray-600 bg-gray-200 rounded-full px-2 py-1">
                                {tech}
                              </div>
                            ))}
                          </div>
                    </div>
                </div>
              ))}
            </div>


        </div>
    </section>
  )
}

const projects = [
  {
    id: 1,
    title: "Events Booking",
    description: "This is an event Landing page platform with animations where people can get everything about hosting an event, eg. Freelancer, decorations,etc.",
    viewLink: "https://barakadanny.github.io/capstone-project-1/",
    image: project1,
    stack: ["HTML", "CSS", "JavaScript"]
  },
  {
    id: 2,
    title: "Coiner",
    description: "Coiner Crypto is a user-friendly platform that provides real-time data and detailed information for tracking cryptocurrency prices.",
    viewLink: "https://coiner-crypto.vercel.app/",
    image: project2,
    stack: ["React", "Coin Gecko API", "zustand", "Axios", "Sass", "Tailwind"]
  },
  {
    id: 3,
    title: "Math-Magicians",
    description: "Math-Magicians is a website that brings together math enthusiasts to explore and engage with various mathematical concepts through an interactive Reactjs-based platform.",
    viewLink: "https://mathmagicianx.netlify.app/",
    image: project3,
    stack: ["React", "CSS"]
  },
  {
    id: 4,
    title: "Air pollution Metrics",
    description: "This is a webapp that allows users to search for air pollution metrics in a given city.",
    viewLink: "https://silver-lamington-1c50bf.netlify.app//",
    image: project4,
    stack: ["CSS", "JavaScript", "React", "Redux", "API", "JEST"]
  }

];

export default Projects
